<template>
  <el-card shadow="never" v-loading="loading">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Finance' }">Finance</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Finance collections' }">
          {{ $root.getHeader() }} Finance Collections
        </el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <div class="rs-card-header">
      <h4 class="wallet-head">
        Collections
      </h4>
    </div>
    <el-table :data="collections" :header-cell-style="{ padding: '0.25rem' }"
      :default-sort="{ prop: 'totalAR', order: 'descending' }" @row-click="routeToCustomer">
      <el-table-column prop="member.company" label="Name" width="250" sortable>
      </el-table-column>
      <el-table-column prop="unitNames" label="Units" width="200">
      </el-table-column>
      <el-table-column prop="achTransaction" label="Pending ACH" width="150" sortable
        :formatter="(_row, _column, cellValue) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)">
      </el-table-column>
      <el-table-column prop="totalAR" label="Total AR" width="200" sortable
        :formatter="(_row, _column, cellValue) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)">
      </el-table-column>
      <el-table-column prop="lt30" label="< 30" width="150"
        :formatter="(_row, _column, cellValue) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)">
      </el-table-column>
      <el-table-column prop="btw30to60" label="30-60" width="150"
        :formatter="(_row, _column, cellValue) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)">
      </el-table-column>
      <el-table-column prop="btw60to90" label="60-90" width="150"
        :formatter="(_row, _column, cellValue) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)">
      </el-table-column>
      <el-table-column prop="gt90" label="> 90"
        :formatter="(_row, _column, cellValue) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)">
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import axios from 'axios';
import { ADMIN_API_BASE } from '../env';
import NoSiteMap from './NoSiteMap.vue';

export default {
  name: 'FinanceCollections',
  props: { facility: { type: String, default: '' } },
  components: { NoSiteMap },
  async mounted() {
    this.loading = true;
    await this.getFacilityCollections();
    this.loading = false;
  },
  watch: {
    async facility() {
      this.loading = true;
      await this.getFacilityCollections();
      this.loading = false;
    },
  },
  data() {
    return {
      collections: [],
      loading: true,
      totalReceivables: [],
    };
  },
  methods: {
    async getFacilityCollections() {
      const response = await axios.get(`${ADMIN_API_BASE}/facilities/${this.facility}/collections`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
        params: {
          leaseTypes: 'active,completed',
        },
      });

      const result = response.data.result;
      // eslint-disable-next-line no-restricted-syntax
      this.collections = result;
    },
    routeToCustomer(row) {
      if (!row.member || !row.member._id) {
        this.$message.error({
          title: 'Error',
          message: 'There was an error while navigating to customer profile.'
        });
        return;
      }

      if (this.facility) {
        this.$router.push({ name: 'Facility Customer', params: { id: row.member._id, facility: this.facility } });
        return;
      }

      this.$router.push({ name: 'Customer', params: { id: row.member._id } });
    },
  },
};
</script>

<style scoped>
.rs-card-header {
  padding: 0.5rem;
  border-bottom: solid 1px #efefef;
  color: #009aca;
}
</style>



// WEBPACK FOOTER //
// src/components/FinanceCollections.vue